import React from 'react';
import { Link } from 'react-router-dom';

export default function UnauthorizedPage() {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🚫 Unauthorized Access</h1>
      <p style={styles.text}>You don't have permission to view this page.</p>
      <Link to="/" style={styles.link}>← Go Back Home</Link>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fef3c7',
    color: '#7c2d12',
    padding: '2rem',
    borderRadius: '1rem',
    margin: '2rem',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)'
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold'
  },
  text: {
    fontSize: '1.2rem',
    marginTop: '1rem'
  },
  link: {
    marginTop: '2rem',
    textDecoration: 'none',
    backgroundColor: '#f59e0b',
    color: 'white',
    padding: '0.6rem 1.2rem',
    borderRadius: '9999px',
    fontWeight: 'bold'
  }
};
